import React from 'react';
import { AdjustedCalc } from '../../types/commission';
import { formatPct, formatUsd } from '../../utils/format';
import { Badge } from '../sf/Badge';
import { NewBadge } from '../sf/NewBadge';
export function AdjustedAmountBlock({
  calc
}: {
  calc: AdjustedCalc;
}) {
  const rows = [{
    label: 'Loan amount',
    value: formatUsd(calc.loanAmount)
  }, {
    label: '× Total Comp Corr %',
    value: formatPct(calc.totalCompPct)
  }, {
    label: '= Comp revenue',
    value: formatUsd(calc.revenue)
  }, {
    label: '− Fee short (halved)',
    value: formatUsd(calc.feeShort)
  }, {
    label: '= Revenue after fee short',
    value: formatUsd(calc.revenueAfterShort),
    negative: calc.revenueAfterShort < 0
  }, {
    label: 'Adjusted Total Comp Corr %',
    value: `${calc.adjustedCompPct.toFixed(4)}%`
  }, {
    label: `÷ Divisor (${calc.divisorRuleKey})`,
    value: formatPct(calc.divisorPct)
  }];
  return <section aria-label="Adjusted Loan Amount" data-id="element-452" data-mp="nqq1wht4hb03">
      <h3 className="mb-2 flex flex-wrap items-center gap-2 text-xs font-semibold text-sf-weak" data-id="element-453" data-mp="ns15aginogqo">
        Adjusted Loan Amount
        {calc.negative && <Badge tone="warning" data-id="element-454" data-mp="2l0azi27jy3mz">Negative comp</Badge>}
      </h3>
      <p className="mb-1.5 text-xs text-sf-weak" data-id="element-455" data-mp="2l0kobmgv24r3">
        Comp type: <span className="text-sf-text" data-id="element-456" data-mp="2pz49vlrjleix">{calc.compType}</span> · Product: <span className="text-sf-text" data-id="element-457" data-mp="2pxjj878cmfqc">{calc.product}</span>
      </p>
      <div className="rounded border border-sf-border" data-id="element-458" data-mp="2urnrcttcott0">
        <dl className="px-3 py-2" data-id="element-459" data-mp="2ys7m5qqgblbz">
          {rows.map(row => <div key={row.label} className="flex justify-between gap-3 py-0.5 text-[13px]" data-id="element-460" data-mp="2yu24qye931cw">
              <dt className="text-sf-weak" data-id="element-461" data-mp="33slvdc3sh1bl">{row.label}</dt>
              <dd className={`tabular-nums ${row.negative ? 'text-sf-red' : ''}`} data-id="element-462" data-mp="38r6vzcmydn0k">{row.value}</dd>
            </div>)}
        </dl>
        <div className="flex justify-between gap-3 border-t border-sf-border bg-sf-bg px-3 py-2 text-[13px] font-semibold" data-id="element-463" data-mp="3dmm8a05bbauv">
          <span data-id="element-464" data-mp="1janvxpbphyur">= Adjusted Loan Amount</span>
          <span className="tabular-nums" data-id="element-465" data-mp="1jbh7d3lm1cj8">{formatUsd(calc.adjustedAmount)}</span>
        </div>
      </div>
      <p className="mt-1.5 text-xs text-sf-weak" data-id="element-466" data-mp="1barmssxdqimt">
        Fee short = ({formatUsd(calc.threshold)} target − {formatUsd(calc.processingCollected)} processing collected − {formatUsd(calc.underwritingCollected)} UW/admin) ÷ 2 ={' '}
        {formatUsd(calc.feeShort)}. Correspondent non-HELOC only. If comp % is at or above the divisor, the Adjusted Loan Amount is the raw loan amount. No cap or floor.
      </p>
      {calc.negative && <p className="mt-1.5 flex flex-wrap items-center gap-1.5 text-xs text-sf-weak" data-id="element-467" data-mp="1pa0t90vs9ydl">
          Main uses ABS() on the comp %, so a negative result still produces an amount.
          <NewBadge label="NEW / requested: $0.00 display, flat $500 / $250 — not applied" data-id="element-468" data-mp="240zx5ylobyqu" />
        </p>}
    </section>;
}